import { motion } from "framer-motion";
import React from "react";
import {
  BsGithub,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaWhatsapp,
} from "../../assets/icons";
import { buttonClick } from "../../utils/animations";

const Footer = () => {
  return (
    <div className=" relative w-full z-10 bg-gray-200 drop-shadow-lg flex flex-col gap-6 items-center justify-start md:items-center md:justify-center h-225 mt-8 py-2">
      <div className="absolute -inset-1 bg-gray-200 blur-sm shadow-sm -z-10"></div>
      <p className="text-4xl text-textColor font-semibold">Vetrivel Ravi</p>
      <div className=" flex items-center gap-12">
        <motion.a
          {...buttonClick}
          href="https://www.facebook.com/velvetri452"
          target="_blank"
        >
          <FaFacebook className=" -rotate-0 text-4xl text-textColor" />
        </motion.a>

        <motion.a
          {...buttonClick}
          href="https://github.com/Vetrivel-VP"
          target="_blank"
        >
          <BsGithub className=" -rotate-0 text-4xl text-textColor" />
        </motion.a>

        <motion.a
          {...buttonClick}
          href="https://www.instagram.com/vetrivel_ravi/"
          target="_blank"
        >
          <FaInstagram className=" -rotate-0 text-4xl text-textColor" />
        </motion.a>

        <motion.a
          {...buttonClick}
          href="https://wa.me/+916382048892"
          target="_blank"
        >
          <FaWhatsapp className=" -rotate-0 text-4xl text-textColor" />
        </motion.a>
      </div>
    </div>
  );
};

export default Footer;
